import React, { useMemo } from 'react';
import Badge from '../../../components/ui/Badge';
import { cn } from '../../../lib/utils';
import { ReferenceDataGeneralList, type ReferenceInboxColumn } from '../ReferenceDataGeneralList';
import { moduleConfig } from './config';
import { useCountries, type Country } from './useData';

const List: React.FC = () => {
  const formatDate = moduleConfig.utils.formatDate;
  const columns = useMemo<ReferenceInboxColumn<Country>[]>(
    () => [
      {
        key: 'name',
        header: 'Name',
        render: (row) => <span className="font-medium">{row.name}</span>,
      },
      {
        key: 'isoCode2',
        header: 'ISO2',
        className: 'hidden whitespace-nowrap sm:table-cell',
        render: (row) => row.isoCode2 || '',
      },
      {
        key: 'isoCode3',
        header: 'ISO3',
        className: 'hidden whitespace-nowrap md:table-cell',
        render: (row) => row.isoCode3 || '',
      },
      {
        key: 'isActive',
        header: 'Active',
        className: 'whitespace-nowrap',
        render: (row) => (
          <Badge variant={row.isActive ? 'success' : 'danger'}>{row.isActive ? 'Yes' : 'No'}</Badge>
        ),
      },
      {
        key: 'createdAt',
        header: 'Created',
        className: 'hidden whitespace-nowrap lg:table-cell',
        render: (row) => <span className={cn('text-sm')}>{formatDate(row.createdAt)}</span>,
      },
    ],
    [formatDate],
  );

  return (
    <ReferenceDataGeneralList
      moduleConfig={moduleConfig}
      useData={useCountries}
      columns={columns}
      defaultSort={{ key: 'name', direction: 'asc' }}
      newLabel="New country"
      getRowLabel={(row) => row.name}
    />
  );
};

export default List;
